import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Button } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'supercabo';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      {(state) => (
        <div>
          <div className="login-supercabo-container" ref={nodeRef}>
            <img src={logo} alt="logo" className="logo-supercabo rounded mx-auto d-block" />
            <Form onSubmit={(event) => onSubmit(event)}>
            <span id="label-username">Login</span>
                  <label className="supercabo-label">
                    <Input
                      className="supercabo-input"
                      disabled={onLogin}
                      required={true}
                      tabIndex={1}
                      type="email"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="supercabo-username"
                      onChange={e => setUsername(e.target.value)}
                    />
                  </label>
                  <span id="label-password">Senha</span>
                  <label className="supercabo-label">
                    <Input
                      className="supercabo-input"
                      required={true}
                      disabled={onLogin}
                      tabIndex={1}
                      type="password"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="supercabo-password"
                      onChange={e => setPassword(e.target.value)}
                    />
                  </label>
                  <Button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-supercabo"
                    disabled={onLogin || !props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </Button>
              {onLogin && <Progress animated color="danger" value={100} />}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
                  <p style={{ fontSize: "19px", marginBottom: '10px' }}>Ainda não tem cadastro?</p>
                  <div className="supercabo-link-register-container">
                    {checkDeviceIOS() ? '' : <a className="supercabo-link-register" href="http://187.63.192.157/centralassinante/Account/Register" target="_blank" rel="noopener noreferrer">Cadastre-se agora</a>}
                  </div>
            </Form>
          </div>
        </div>
      )}
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
